import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-awesome-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade direction="up" duration={1000} triggerOnce>
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          Copy right ©️  Hai Nguyen
        </p>
        <p className={isDark ? "dark-mode footer-text-theme" : "footer-text-theme"}>
          Theme by{" "}
          <a href="https://github.com/saadpasta/developerFolio" target="_blank"  rel="noopener noreferrer">
            developerFolio
          </a>
        </p>
      </div>
    </Fade>
  );
}
